import { ETaxonomy, SelectItem } from "library/types";
import { useMemo } from "react";
import { useTaxonomyOptions } from "./useTaxonomyOptions";

const ratesCountryCurrencies = {
  "Currency.EUR": true, // Euro
  // "Currency.BGN": true, // Bulgaria - Lev
  "Currency.HUF": true, // Hungary - Forint
  "Currency.PLN": true, // Poland - Zloty
  "Currency.RON": true, // Romania - Leu
  "Currency.RSD": true, // Serbia - Dinar
  "Currency.TRY": true, // Turkey - Lira
};

export function useGetCurrencyOptionsForRateCalculation(
  selectedCurrency?: SelectItem | null,
) {
  const currencyOptions = useTaxonomyOptions(ETaxonomy.Currency);

  return useMemo(() => {
    const baseOptions = currencyOptions.filter(
      (option: SelectItem) => option.code && ratesCountryCurrencies[option.code],
    );

    const hasSelected =
      !selectedCurrency ||
      baseOptions.some((o: SelectItem) => o.value === selectedCurrency.value);

    return hasSelected ? baseOptions : [...baseOptions, selectedCurrency];
  }, [currencyOptions, selectedCurrency]);
}
